@if (qrCode(); as qr) {
    <svg class="ft-qr-code"
         role="img"
         [attr.aria-label]="ariaLabel()"
         [attr.width]="size()"
         [attr.height]="size()"
         [attr.viewBox]="qr.viewBox"
         shape-rendering="crispEdges">
        <!-- Explicit light ground: the quiet zone only works if it is actually light, and the
             modal background cannot be relied on to show through. -->
        <rect [attr.width]="qr.size" [attr.height]="qr.size" fill="#ffffff" />
        <path [attr.d]="qr.d" fill="#000000" />
    </svg>
}
